import { TreeNode } from '../route-builder';

export const IncentiveSupportModule = {
  segment: 'incentive-support',
  children: {
    IncentiveSupportComponent: { segment: '' },
    IncentiveSupportReassignmentsComponent: { segment: 'reassignments' },
    IncentiveSupportMonitoringComponent: { segment: 'monitoring' },
    IncentiveSupportAchievementComponent: { segment: 'achievement' }
  }
} as const satisfies TreeNode;
